import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


interface CreateLocalProgramDialogData {
  name: string;
  description: string;
  buttonTextConfirm: string;
  type: string;
  url: string;
  user: string;
  pass: string;
}

@Component({
  selector: 'app-create-task-dialog',
  templateUrl: './create-program-dialog.component.html',
  styleUrls: ['./create-program-dialog.component.scss']
  })
export class CreateProgramDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<CreateProgramDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateLocalProgramDialogData) { }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close();
  }
}
